import script from "./NbsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./NbsCard.vue?vue&type=script&setup=true&lang=js"

import "./NbsCard.vue?vue&type=style&index=0&id=0afda9d6&lang=scss"

const __exports__ = script;

export default __exports__